import React from 'react'
import { DropDown, RollingLoader } from '../../../commons'
import { categoryOfClientDropDown } from '../../../../constant/clientDirectoryDropDown';
import Select from 'react-select';
import { returnInputFieldLength } from '../../../../utils/commonFunctions';

type AppProps = {
    clientAadharUniqueCheckFetching: boolean;
    clientAadharUniqueCheckMessage: string | null;
    othersDetails: any;
    handleOtherDetailsChange: (data: any) => void;
    handleCategoryOfClientChange: (data: any) => void;
    setRegistrationsInputDetails: any;
     isDisabled?:boolean
}
const Others = ({
    clientAadharUniqueCheckFetching,
    clientAadharUniqueCheckMessage,
    othersDetails,
    handleOtherDetailsChange,
    handleCategoryOfClientChange,
    setRegistrationsInputDetails,
    isDisabled
}: AppProps) => {
    const option = [
        {
            value: "No",
            label: "No"
        },
        {
            value: "Yes",
            label: "Yes"
        }
    ]

    const handleBlackListChange = (data: any) => {
        setRegistrationsInputDetails((prev: any) => {
            return {
                ...prev,
                others: {
                    ...prev.others,
                    blackListed: {
                        value: data?.value,
                        label: data?.label
                    }
                }
            }
        })
    }
    return (
        <>
            <div className='row'>
                <div className="col-md-3">
                    <label htmlFor="blackListed">Black Listed</label>
                    <DropDown
                        options={option}
                        value={othersDetails?.blackListed}
                        handleChange={handleBlackListChange}
                        disabled={isDisabled}
                    />
                </div>
                <div className="col-md-3">
                    <label htmlFor="numberOfEmployees">Number of Employees</label>
                    <div className="d-flex flex-row position-relative">
                        <input
                            type="number"
                            className="form-control"
                            name="numberOfEmployees"
                            value={othersDetails?.numberOfEmployees}
                            onChange={handleOtherDetailsChange}
                            onWheel={(event) => event.currentTarget.blur()}
                            disabled={isDisabled}

                        />
                    </div>
                </div>
                <div className="col-md-3">
                    <label htmlFor="turnoverInCrores">Turnover (in Crores)</label>
                    <div className="d-flex flex-row position-relative">
                        <input
                            type="number"
                            className="form-control"
                            name="turnoverInCrores"
                            value={othersDetails?.turnoverInCrores}
                            onChange={handleOtherDetailsChange}
                            onWheel={(event) => event.currentTarget.blur()}
                            disabled={isDisabled}
                        />
                    </div>
                </div>
                <div className="col-md-3">
                    <label htmlFor="lie">LIE</label>
                    <div className="d-flex flex-row position-relative">
                        <input
                            type="text"
                            className="form-control"
                            name="lie"
                            value={othersDetails?.lie}
                            onChange={handleOtherDetailsChange}
                            disabled={isDisabled}
                        />
                    </div>
                </div>
            </div>
            <div className='row'>
                <div className="col-md-3 mt-3">
                    <label htmlFor="lin">LIN</label>
                    <div className="d-flex flex-row position-relative">
                        <input
                            type="text"
                            className="form-control"
                            name="lin"
                            value={othersDetails?.lin}
                            onChange={handleOtherDetailsChange}
                            disabled={isDisabled}
                        />
                    </div>
                </div>
                <div className="col-md-3 mt-3">
                    <label htmlFor="aadhaarNo">AADHAAR No</label>
                    <div className="d-flex flex-row position-relative">
                        <input
                            type="number"
                            className={`form-control ${clientAadharUniqueCheckMessage?.includes("Aadhaar number already exists")?"error-border":""}`}
                            name="aadhaarNo"
                            value={othersDetails?.aadhaarNo}
                            onChange={handleOtherDetailsChange}
                            onWheel={(event) => event.currentTarget.blur()}
                            disabled={isDisabled}
                            // maxLength={12}
                        />
                        {clientAadharUniqueCheckFetching && othersDetails?.aadhaarNo && <RollingLoader />}
                    </div>
                    {/* <span className="input-length">
                            {returnInputFieldLength(othersDetails?.aadhaarNo?.length, 12)}
                        </span> */}
                    <div>
                        <span className="text-danger" style={{fontSize:"12px"}}>
                            {clientAadharUniqueCheckMessage?.includes("Aadhaar number already exists") && <span>Aadhaar number already exists</span>}
                        </span>
                    </div>

                </div>
                <div className="col-md-3 mt-3">
                    <label htmlFor="categoryOfClient">Category of Client</label>
                    <Select
                        options={categoryOfClientDropDown}
                        value={othersDetails?.categoryOfClient}
                        onChange={handleCategoryOfClientChange}
                         isDisabled={isDisabled}
                    />
                </div>
            </div>
            <div className='row'>
                <div className="col-md-6 mt-3">
                    <label htmlFor="businessNature">Business Nature</label>
                    <div className="d-flex flex-row position-relative">
                        <input
                            type="text"
                            className="form-control"
                            name="businessNature"
                            value={othersDetails?.businessNature}
                            onChange={handleOtherDetailsChange}
                            disabled={isDisabled}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}

export default Others